import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';

import { ReactiveFormsModule } from '@angular/forms';

import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ResetPasswordModule } from './modules/reset-password/reset-password.module';
import { CommonItemsModule } from 'src/common-items/common-items.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { ApmErrorHandler, ApmModule, ApmService } from "@elastic/apm-rum-angular";
import { environment } from 'src/environments/environment';
import { initApmRumAgent } from './app.helper';
import { BassScaResetPasswordModule } from './modules/bass-sca/bass-sca-reset-password.module';


// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    ApmModule,
    BrowserModule, 
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    CommonItemsModule,
    ResetPasswordModule,
    BassScaResetPasswordModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  }),
    BrowserAnimationsModule
  ],
  providers: [
    ApmService,
    CookieService,
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler
    },
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(
    private apmService: ApmService,
  ){
    initApmRumAgent(environment.env, this.apmService);
  }
}